import {useQuickFilter} from './useQuickFilter';

export const useAppliedQuickFilter = () => {
  const {appliedQuickFilter} = useQuickFilter();
  return appliedQuickFilter;
};
